import { render, staticRenderFns } from "./ApproversOc.vue?vue&type=template&id=4329ce4d"
import script from "./ApproversOc.vue?vue&type=script&lang=js"
export * from "./ApproversOc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports